import axios, { AxiosResponse } from 'axios';

const url = '/services/isnaportal/open-api';

const dictionarySynchronizationUrl =
    '/services/isnaportalsync/api/dictionary-synchronization';

export const synchronizeAllDictionaries = (): Promise<AxiosResponse> => {
    return axios.post(dictionarySynchronizationUrl);
};

export const getAutomatedDictionary = (): Promise<AxiosResponse> => {
    return axios.get(`${dictionarySynchronizationUrl}/available`);
};

export const synchronizeDictionary = (
    armDictionaryCode: string
): Promise<AxiosResponse> => {
    return axios.post(dictionarySynchronizationUrl, null, {
        params: {
            codes: armDictionaryCode,
        },
    });
};

export const getDownloadableDictionary = (params: any): Promise<AxiosResponse> => {
    return axios.get(`${url}/uploaded-dictionary-list`, {
        params,
    });
};

export const updateDictionaryTs = (params: any): Promise<AxiosResponse> => {
    return axios.get(`${url}/load-dictionary-ts`, {
        params,
    });
};

export const updateDictionaryData = (params: any): Promise<AxiosResponse> => {
    return axios.get(`${url}/load-dictionary-data`, {
        params,
    });
};

export const deleteDictionary = (id: number): Promise<AxiosResponse> => {
    return axios.delete(`${url}/delete-uploaded-dictionary/${id}`);
};

export const addDictionary = (data: any): Promise<AxiosResponse> => {
    return axios.post(`${url}/import-dictionary`, data, {
        headers: {
            mimeType: 'multipart/form-data',
        },
    });
};

export const downloadAdminDictionary = (
    metaDocumentId: any,
    tokenStr: string
): Promise<AxiosResponse> => {
    return axios.get(`${url}/download-uploaded-dictionary/${metaDocumentId}`, {
        responseType: 'blob',
        headers: {
            Accept: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
            Authorization: `${tokenStr}`,
        },
    });
};

export const downloadDictionary = (params: any, dto?: any): Promise<AxiosResponse> => {
    return axios.post(`${url}/download-dictionary`, dto, {
        params,
        responseType: 'blob',
    });
};

export const filterDictionary = (
    params: any,
    dto?: any,
    recaptchaToken?: string
): Promise<AxiosResponse> => {
    return axios.post(`${url}/filter-dictionary`, dto, {
        params,
        headers: {
            recaptchaToken,
        },
    });
};
